<template>
  <section v-if="crew.length" id="crew" class="crew-section">
    <v-container>
      <p>The People</p>
      <h2>The Reckon Crew</h2>
      <div class="crew-grid">
        <router-link
          v-for="member in crew"
          :key="member.employeeSlug || member.id || member.name"
          :to="passportRoute(member)"
          class="crew-card"
        >
          <v-icon>mdi-account-circle-outline</v-icon>
          <span>{{ member.displayName || member.name }}</span>
          <strong>{{ member.role }}</strong>
          <small v-if="member.employeeSlug">View Passport <v-icon x-small>mdi-arrow-right</v-icon></small>
        </router-link>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'CrewSection',
  props: { crew: { type: Array, default: () => [] } },
  methods: {
    passportRoute(member) {
      return member.employeeSlug
        ? { name: 'passport', params: { employeeSlug: member.employeeSlug } }
        : { name: 'reckon-way' };
    },
  },
};
</script>

<style scoped>
.crew-section { background: #050505; border-top: 1px solid #242424; padding: 72px 0; scroll-margin-top: 68px; }
.crew-section > .container > p { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: 2.8rem; margin: 0 0 28px; }
.crew-grid { display: grid; gap: 14px; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); }
.crew-card { background: #121212; border: 1px solid #2c2c2c; border-radius: 10px; color: #fff; display: grid; padding: 24px; text-decoration: none; }
.crew-card > .v-icon { color: #f0b13c; margin-bottom: 20px; }
.crew-card span { font-family: "Oswald", sans-serif; font-size: 1.35rem; font-weight: 800; }
.crew-card strong { color: #aaa; font-size: 0.86rem; margin-top: 4px; }
.crew-card small { color: #f0b13c; margin-top: 18px; }
.crew-card small .v-icon { color: inherit; }
</style>
